import { lazy } from "react";

export const NewLessonPage = lazy(() => import("./newLessonPage"));
